import React, { useState } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { getAuth, GoogleAuthProvider, signInWithCredential } from "firebase/auth";
import keys from 'utils/keys';
import Config from "utils/Config";

const clientId = keys.google.prod;

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const GoogleLoginComponent = () => {
    const handleLoginSuccess = async (response) => {
      setLoading(true);
      setError('');
      try {
        const accessToken = response['access_token'];
        const credential = GoogleAuthProvider.credential(null, accessToken);
        await signInWithCredential(getAuth(), credential);
      } catch (err) {
        setError(err.message);
      }
      setLoading(false);
    };

    const handleLoginFailure = (err) => {
      setError(err.message);
    };

    const login = useGoogleLogin({
      onSuccess: handleLoginSuccess,
      onError: handleLoginFailure
    });

    return (
      <button
        type="button"
        className="flex justify-center gap-3 items-center h-[59px] lg:h-[80px] rounded-full border border-blue-default w-full shadow-shadow bg-white transform transition-transform duration-300 hover:scale-105 disabled:opacity-50 disabled:hover:scale-100"
        onClick={() => login()}
        disabled={loading}
      >
        <span className="text-md lg:text-xl text-[inherit]">Sign in with Google</span>
      </button>
    );
  };

  return (
    <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Login</h1>
        <p className="text-gray-600">Please sign in with Google to access the admin dashboard</p>
      </div>

      <GoogleOAuthProvider clientId={clientId}>
        <GoogleLoginComponent />
      </GoogleOAuthProvider>

      {error && (
        <div className="mt-4 p-3 rounded-md bg-red-100 text-red-700">
          {error}
        </div>
      )}

      {loading && (
        <div className="mt-4 text-center text-gray-600">
          Loading...
        </div>
      )}
    </div>
  );
};

export default AdminLogin;
